import React from "react";
import "./Home.css";
import nourTuneLogo from "../../nourtunelogohome.png";

const Navbar = () => {
  return (
    <nav className="nav">
      <div className="nav-container">

        <div className="nav-left">
          <div className="nav-logo">
            <img src={nourTuneLogo} alt="NourTune Logo" />
            <span className="nav-brand">NourTune</span>
          </div>

          <div className="nav-links">
            <a href="#features">Features</a>
            <a href="#about">About</a>
            <a href="#launch">Launch</a>
          </div>
        </div>

        {/* Right Side */}
        <div className="nav-right">
          <button className="nav-launch-soon">
            Launch Soon
          </button>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;